import type {
  ApiTimezoneListQuery,
  ApiTimezoneListResponse,
} from '@highimpact-frontend/api-types';
import { api_config } from '../../../api-commons';
import type { ITimezoneService } from './ITimezoneService';

class TimezoneService implements ITimezoneService {
  async getTimezones(
    params?: ApiTimezoneListQuery
  ): Promise<ApiTimezoneListResponse> {
    const response = await api_config.get('/timezones', { params });
    return response.data;
  }
}

const instance = new TimezoneService();
export default instance;
